'use strict';

const pushNotification = (posTop, posRight, title, description, type) => {
  const notificationBox = document.createElement('div');

  notificationBox.className = `notification ${type}`;

  const titleElement = document.createElement('h2');

  titleElement.className = `title`;
  titleElement.textContent = title;

  const paragraphElement = document.createElement('p');

  paragraphElement.className = `description`;
  paragraphElement.textContent = description;

  notificationBox.append(titleElement, paragraphElement);
  document.body.append(notificationBox);

  notificationBox.style.top = posTop + 'px';
  notificationBox.style.right = posRight + 'px';

  setTimeout(() => {
    notificationBox.style.display = 'none';
  }, 2000);
};

pushNotification(
  10,
  10,
  'Title of Success message',
  'Message example.\n ' + 'Notification should contain title and description.',
  'success',
);

pushNotification(
  150,
  10,
  'Title of Error message',
  'Message example.\n ' + 'Notification should contain title and description.',
  'error',
);

pushNotification(
  290,
  10,
  'Title of Warning message',
  'Message example.\n ' + 'Notification should contain title and description.',
  'warning',
);
